import { AxiosPromise } from 'axios';

import { api } from './api';

export class MediaAPI {
  static postMedia(
    mediaFile: string | Blob,
    targetEntity: string | null = null,
  ): AxiosPromise {
    const formData = new FormData();
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };

    formData.append('file', mediaFile);
    if (targetEntity) {
      formData.append('targetEntity', targetEntity);
    }
    return api.post('/media-objects.jsonld', formData, config);
  }
}
